import React from 'react';

/**
 * Tailwind Spin Component - заміна Ant Design Spin
 */
export const TailwindSpin = ({ 
  size = 'default', 
  className = '',
  tip,
  spinning = true,
  children 
}) => {
  if (!spinning && children) {
    return children;
  }

  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-8 h-8',
    large: 'w-12 h-12',
  };

  const spinner = (
    <div className={`inline-block ${sizeClasses[size] || sizeClasses.default} ${className}`}>
      <svg
        className="animate-spin text-[#7AE9FF]"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  );

  if (children) {
    return (
      <div className="relative">
        {spinning && (
          <div className="absolute inset-0 flex items-center justify-center bg-[rgba(5,6,9,0.8)] backdrop-blur-sm z-50 rounded-lg">
            <div className="text-center">
              {spinner}
              {tip && (
                <p className="mt-2 text-[rgba(247,243,234,0.7)] font-body text-sm">{tip}</p>
              )}
            </div>
          </div>
        )}
        <div className={spinning ? 'opacity-50 pointer-events-none' : ''}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-8">
      {spinner}
      {tip && (
        <p className="mt-4 text-[rgba(247,243,234,0.7)] font-body text-sm">{tip}</p>
      )}
    </div>
  );
};

export default TailwindSpin;

